import { useEffect, useState } from 'react';
import * as _ from 'lodash';
import { Modal, Button, FormControl } from 'react-bootstrap';
import usePrevious from '@nkr/services/use-previous';

interface IProps {
    show: boolean,
    centerId: number,
    centerAlias: string,
    notes: string,
    targetedProductList: string[],
    onSave: (centerId: number, notes: string) => void,
    onCancel: () => void
}

const CenterNotes = (props: IProps) => {
    const [notes, setNotes] = useState('');
    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show) {
            setNotes(props.notes);
        }
    }, [props.show]);

    const handleNotesChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        setNotes(e.currentTarget.value);
    };

    const handleSave = () => {
        props.onSave(props.centerId, notes);
    };

    const targetedProductList = props.targetedProductList.join(', ');

    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                Center Notes for {props.centerAlias}
            </Modal.Header>

            <Modal.Body>
                {props.targetedProductList.length > 0 ?
                    <div className='alert alert-info' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>
                        <div style={{ fontWeight: 500 }}>Targeted Products</div>
                        <div>{targetedProductList}</div>
                    </div>
                    :
                    <div className='alert alert-info'>
                        <div style={{ fontWeight: 500 }}>Targeted Products</div>
                        <div>No targeted products</div>
                    </div>
                }

                <FormControl
                    componentClass='textarea'
                    style={{ height: 150, resize: 'none' }}
                    value={notes}
                    onChange={handleNotesChange}
                />
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleSave}>Save Notes</Button>
                <Button onClick={props.onCancel}>Discard Changes &amp; Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CenterNotes;